import type { InputRef } from "antd";
import { Table } from "antd";
import type { FilterConfirmProps } from "antd/es/table/interface";
import { useEffect, useRef, useState } from "react";

import { createFaceCallSongsColumns } from "./content/faceCallColumns";
import { FilterType, SongDataIndex, SongType } from "./content/faceCallTypes";
import { fetchFaceCallSongs } from "./services/faceCall.services";

const SongsTabContent = () => {
  const [dateFilter, setDateFilter] = useState<FilterType[]>([]);
  const [songsData, setSongsData] = useState<SongType[]>();
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef<InputRef>(null);

  const handleSearch = (
    selectedKeys: string[],
    confirm: (param?: FilterConfirmProps) => void,
    dataIndex: SongDataIndex
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText("");
  };

  const getSongsList = async () => {
    const data = await fetchFaceCallSongs();

    if (data?.data) {
      const songs = data.data;

      const uniqueCategory = [
        ...new Set<string>(songs.map((song: SongType) => song.category)),
      ].sort((a, b) => a.localeCompare(b));

      const filterFormCategory = uniqueCategory.map((item) => ({
        text: item,
        value: item,
      }));

      setDateFilter(filterFormCategory)
      setSongsData(songs)
    }
  }

  useEffect(() => {
    getSongsList();
  }, []);

  return (
    <>
      <div className="table-container">
        <Table
          rowKey={(record: SongType) => record.songId}
          columns={createFaceCallSongsColumns(
            dateFilter,
            searchInput,
            searchText,
            searchedColumn,
            handleSearch,
            handleReset)}
          dataSource={songsData}
          pagination={{ hideOnSinglePage: true, pageSize: 10 }}
        />
      </div>
    </>
  );
};

export default SongsTabContent;
